<template>
  <div>
    <div class="row">
      <div class="card">
        <div class="row no-gutters">
          <div class="col-lg-12">
            <div class="login-header">
              <img class="logo" src="img/brand/logo-single.png" />
              <div class="header-text-container">
                <h1 style="line-height: 3" class="login-header-message">
                  <span>ورود به سایت</span>
                </h1>
              </div>
            </div>
            <validation-observer
              v-slot="{ invalid, handleSubmit }"
              ref="formValidator"
            >
              <b-form
                class="form-signin"
                role="form"
                @submit.prevent="handleSubmit().then(onSubmit)"
              >
                <div class="login-form-fields">
                  <p class="login-form-message">
                    برای ورود در سایت لطفا شماره تماس و رمز عبور خود را وارد
                    نمایید.
                  </p>

                  <base-input
                    placeholder="شماره موبایل"
                    type="tel"
                    class="text-input"
                    :rules="{ required: true, regex: /^(\+98|0)?9\d{9}$/g }"
                    autofocus
                    name="شماره موبابل"
                    v-model="model.phoneNumber"
                  ></base-input>

                  <base-input
                    placeholder=" رمز عبور"
                    type="password"
                    name="رمز عبور"
                    :rules="{ required: true, min: 2 }"
                    class="text-input mt-1"
                    v-model="model.password"
                  ></base-input>

                  <div class="auth-link mt-2">
                    <b-link :to="{ name: 'recovery-enter-number' }">
                      فراموشی رمز عبور
                    </b-link>
                  </div>
                  <!-- <div v-if="siteKey">
                    <vue-recaptcha
                      class="mb-5"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyMethod"
                    ></vue-recaptcha>
                  </div> -->

                  <b-overlay
                    :show="busy"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class="d-inline-block"
                  >
                    <button
                      class="btn btn-lg btn-block submit-button"
                      type="submit"
                      :disabled="invalid"
                    >
                      <b-icon
                        v-if="busy"
                        icon="circle-fill"
                        animation="throb"
                        font-scale="1"
                      ></b-icon>
                      ورود به پنل
                    </button>
                  </b-overlay>
                </div>
              </b-form>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";
export default {
  components: { VueRecaptcha },
  data() {
    return {
      busy: false,
      timeout: null,
      siteKey: "",

      initPhoneNumberExample: "",
      results: null,

      model: {
        countryCode: "98",
        phoneNumber: "",
        password: "",
        capcha: false,
      },
      recaptcha: null,
    };
  },
  mounted() {
    this.siteKey = process.env.VUE_APP_SITE_KEY;
  },
  beforeDestroy() {
    this.clearTimeout();
  },
  methods: {
    verifyMethod(res) {
      this.recaptcha = res;
    },
    onSubmit() {
      this.busy = true;

      this.setTimeout(() => {
        this.busy = false;
      });
      // this will be called only after form is valid. You can do api call here to login
      // let countryCode = "+" + this.results.countryCallingCode;
      let countryCode = "+98";
      // let phoneNumber = this.results.nationalNumber;
      let phoneNumber = this.model.phoneNumber;
      let password = this.model.password;

      this.$store
        .dispatch("login", { countryCode, phoneNumber, password })
        .then((response) => {
          this.busy = false;

          // this.makeToast("success", "ورود موفق", "ورود با موفقیت انجام شد");
          this.$router.push("/login-code");
          // window.location.replace("/dashboard");
        })
        .catch((err) => {
          console.log(err);

          this.$swal({
            position: "center",
            icon: "error",
            title: "نام کاربری یا رمز عبور شما صحیح نیست",
            showConfirmButton: false,
            timer: 1500,
          });
          this.busy = false;
          let errorResponse = this.errorHandler(err);
        });
    },
    makeToast(variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    clearTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    },
    setTimeout(callback) {
      this.clearTimeout();
      this.timeout = setTimeout(() => {
        this.clearTimeout();
        callback();
      }, 10000);
    },
  },
};
</script>

<style></style>
<style scoped>
.login-header {
  border-bottom: none;
  padding-bottom: 0;
}
</style>
